var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5007 13.5H7.83398C7.56065 13.5 7.33398 13.2733 7.33398 13C7.33398 12.7267 7.56065 12.5 7.83398 12.5H14.5007C14.774 12.5 15.0007 12.7267 15.0007 13C15.0007 13.2733 14.774 13.5 14.5007 13.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5007 8.83398H7.83398C7.56065 8.83398 7.33398 8.60732 7.33398 8.33398C7.33398 8.06065 7.56065 7.83398 7.83398 7.83398H14.5007C14.774 7.83398 15.0007 8.06065 15.0007 8.33398C15.0007 8.60732 14.774 8.83398 14.5007 8.83398Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5007 4.16602H7.83398C7.56065 4.16602 7.33398 3.93935 7.33398 3.66602C7.33398 3.39268 7.56065 3.16602 7.83398 3.16602H14.5007C14.774 3.16602 15.0007 3.39268 15.0007 3.66602C15.0007 3.93935 14.774 4.16602 14.5007 4.16602Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16695 4.83427C3.04029 4.83427 2.91362 4.7876 2.81362 4.6876L2.14695 4.02094C1.95362 3.8276 1.95362 3.5076 2.14695 3.31427C2.34029 3.12094 2.66029 3.12094 2.85362 3.31427L3.16695 3.6276L4.81362 1.98094C5.00695 1.7876 5.32695 1.7876 5.52029 1.98094C5.71362 2.17427 5.71362 2.49427 5.52029 2.6876L3.52029 4.6876C3.42029 4.7876 3.29362 4.83427 3.16695 4.83427Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16695 9.50029C3.04029 9.50029 2.91362 9.45362 2.81362 9.35362L2.14695 8.68695C1.95362 8.49362 1.95362 8.17362 2.14695 7.98029C2.34029 7.78695 2.66029 7.78695 2.85362 7.98029L3.16695 8.29362L4.81362 6.64695C5.00695 6.45362 5.32695 6.45362 5.52029 6.64695C5.71362 6.84029 5.71362 7.16029 5.52029 7.35362L3.52029 9.35362C3.42029 9.45362 3.29362 9.50029 3.16695 9.50029Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16695 14.1663C3.04029 14.1663 2.91362 14.1196 2.81362 14.0196L2.14695 13.353C1.95362 13.1596 1.95362 12.8396 2.14695 12.6463C2.34029 12.453 2.66029 12.453 2.85362 12.6463L3.16695 12.9596L4.81362 11.313C5.00695 11.1196 5.32695 11.1196 5.52029 11.313C5.71362 11.5063 5.71362 11.8263 5.52029 12.0196L3.52029 14.0196C3.42029 14.1196 3.29362 14.1663 3.16695 14.1663Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTask);
export default __webpack_public_path__ + "static/media/icon_task.1a3f5d660b2576d988cec57fdb50e69e.svg";
export { ForwardRef as ReactComponent };